import React, { Component } from 'react'
import { compose } from 'react-apollo'
import Styled from 'styled-components'

import PageLoader from 'components/PageLoader'
import Content from 'components/Content'
import Columns from 'components/Columns'
import Column from 'components/Column'
import ProjectCard from 'components/ProjectCard'
import AddCard from 'components/AddCard'

import { projects as projectsQuery } from 'components/Projects/queries'

const ContentExtended = Styled(Content)`
  padding: 3rem 0;
`

class Projects extends Component {
  render() {
    if (this.props.loading) {
      return (
        <PageLoader />
      )
    }

    return (
      <ContentExtended>
        <Columns>
          {this.props.projectAssociations.map(({ project }) => (
            <Column key={project._id} small={24} medium={12} large={8}>
              <ProjectCard project={project} />
            </Column>
          ))}

          <Column small={24} medium={12} large={8}>
            <AddCard
              to="/projects/create"
              liga="add_circle"
              label="Create Project"
            />
          </Column>
        </Columns>
      </ContentExtended>
    )
  }
}

export default compose(
  projectsQuery
)(Projects)



// WEBPACK FOOTER //
// ./src/components/Projects/index.js